import getEnabledItems from '@lyearn/core/utils/array/getEnabledItems';
import { TFunction } from '@lyearn/i18n';
import {
  ArchiveOutline,
  EditOutline,
  EmailOutline,
  Link2Outline,
  MaskOutline,
  Undo2Outline,
} from '@lyearn/icons';
import { ActionMenuItemType } from '@lyearn/molecules';
import { LearnerProfileActionTypes } from '@/modules/learner/views/LearnerProfile/hooks/useLearnerProfile/actions';
import { UserStatusEnum } from '@/types/schema';

import { LearnerProfileDetailsFragment } from '../../../../graphql/fragments/generated/LearnerProfileDetails';

export const getLearnerHeaderActionItems = (
  t: TFunction,
  learner: LearnerProfileDetailsFragment,
  isSelf: boolean,
  canMasquerade: boolean,
) =>
  getEnabledItems([
    {
      id: LearnerProfileActionTypes.SetInViewModal,
      EndIcon: EditOutline,
      label: t('Common:EditProfile'),
      enabled: learner.status === UserStatusEnum.Active,
    },
    {
      id: LearnerProfileActionTypes.Reactivate,
      EndIcon: Undo2Outline,
      label: t('Common:Actions.Reactivate'),
      enabled: learner.status === UserStatusEnum.Archived,
    },
    {
      id: LearnerProfileActionTypes.ShareLearnerProfile,
      EndIcon: Link2Outline,
      label: t('Common:Copylink'),
      enabled: true,
    },
    {
      id: LearnerProfileActionTypes.ResetPassword,
      EndIcon: EmailOutline,
      label: t('Common:Actions.ResetPassword'),
      enabled: Boolean(learner.emailId && learner.status === UserStatusEnum.Active),
    },
    {
      id: LearnerProfileActionTypes.Masquerade,
      EndIcon: MaskOutline,
      label: t('Common:Actions.Masquerade'),
      enabled: canMasquerade,
    },
    {
      id: LearnerProfileActionTypes.Deactivate,
      EndIcon: ArchiveOutline,
      appearance: 'danger',
      label: t('Common:Actions.Deactivate'),
      enabled: !isSelf && learner.status === UserStatusEnum.Active,
    },
  ]) as ActionMenuItemType[];
